import axios from "axios";
import {
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile,
} from "NetworkCall";
import {
  APP_API_KEY,
  INSTANCE_URL,
  BASE_IMAGES_URL,
  itemCount,
  MAIN_URL,
} from "Constants";
import _ from "lodash";

export var CLIENTDATA_FROM_TABLE = "CLIENTDATA_FROM_TABLE";
export var ALLEVENTS_UNDER_CLIENT = "ALLEVENTS_UNDER_CLIENT";
export var CLIENT_HISTORY_DETAILS = "CLIENT_HISTORY_DETAILS";
export var TOTAL_ACCOUNT_USAGE_CLIENT = "TOTAL_ACCOUNT_USAGE_CLIENT";
export var USAGE_HISTORY_DATA = "USAGE_HISTORY_DATA";
export var ADMIN_ISSUE_TOKEN_OPEN = "ADMIN_ISSUE_TOKEN_OPEN";
export var ADMIN_ISSUE_TOKEN_CLOSE = "ADMIN_ISSUE_TOKEN_CLOSE";
export var ALLEVENTS_UNDERCLIENT = "ALLEVENTS_UNDERCLIENT";
export var EVENTSUNDERCLIENT = "EVENTSUNDERCLIENT";
export var SINGLEREPORT = "SINGLEREPORT";

export function fetchClientalldetails(session, clientid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/clients?filter=clientid=${clientid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: CLIENTDATA_FROM_TABLE, payload: data.resource });
        callback({ status: 1, data: data.resource });
      },
      (error) => {}
    );
  };
}
export function fetchallEventunderClient(session, groupnumber) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=(group_number=${groupnumber})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: ALLEVENTS_UNDER_CLIENT, payload: data.resource });
      },
      (error) => {}
    );
  };
}

export function fetchtotalaccountusageofclient(session, clientid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    postRequest(
      url,
      {
        session: session,
        eventid: session.eventid,
        clientid: clientid,
        type: "clients_accountusage",
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: TOTAL_ACCOUNT_USAGE_CLIENT,
          payload: { count: response.count },
        });

        callback({ status: 1, data: response.count });
      },
      (error) => {}
    );
  };
}
// export function fetchclientbillinghistory(
//   session,
//   pageCount = 0,
//   countPerPage = 0,
//   clientid,

//   callback
// ) {
//   var perPage = itemCount;
//   if (countPerPage !== 0) perPage = countPerPage;

//   var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

//   var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

//   return (dispatch) => {
//     postRequest(
//       url,
//       {
//         session: session,
//         eventid: session.eventid,
//         clientid:clientid,
//         limit: itemCount,
//         offset: offset,
//         type: "clients_billinghistory",
//       },
//       session,
//       dispatch,
//       (response) => {
//         if (response.client_history_data.length === 0) {
//           dispatch({
//             type: CLIENT_HISTORY_DETAILS,
//             payload: { data: {}, count: 0 },
//           });
//         } else {
//           dispatch({
//             type: CLIENT_HISTORY_DETAILS,
//             payload: {
//               data: response.client_history_data,
//               count: response.count,
//             },
//           });
//         }

//         callback({ status: 1 });
//       },
//       (error) => {}
//     );
//   };
// }

export function fetchclientbillinghistory(
  session,
  pageCount = 0,
  clientid,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/clientinvoice?fields=*&related=*&include_count=true&filter=clientid=${clientid}&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length === 0) {
          dispatch({
            type: CLIENT_HISTORY_DETAILS,
            payload: { data: {}, count: 0 },
          });
        } else {
          dispatch({
            type: CLIENT_HISTORY_DETAILS,
            payload: {
              data: data.resource,
              count: data.meta.count,
            },
          });
        }
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchclientaccountusage_history(session, clientid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    postRequest(
      url,
      {
        eventid: session.eventid,
        clientid: clientid,
        type: "clientaccountusage_history",
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: USAGE_HISTORY_DATA,
          payload: { data: response.data, eventdata: response.eventdata },
        });

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function uploadreportedAttachments(
  session,
  uploadFiles,
  clientid,
  callback
) {
  var eventid = session.eventid;
  var filecontent = uploadFiles.media;
  var filename = `clients/${clientid}/supportticket/${uploadFiles.name}`;
  var filetype = uploadFiles.type;

  const dataMedia = new FormData();
  if (filetype === "video") {
    var blob = new Blob([filecontent], { type: "video/mp4" });
  } else if (filetype === "audio") {
    var blob = new Blob([filecontent], { type: "audio/mp3" });
  } else if (filetype === "image") {
    var blob = new Blob([filecontent], { type: "image/jpeg" });
  } else {
    var blob = new Blob([filecontent], { type: filetype });
  }

  dataMedia.append("files", blob, filename);

  return (dispatch) => {
    uploadEncodedFile(
      `${BASE_IMAGES_URL}/clients/${clientid}/supportticket/`,
      session,
      dataMedia,
      dispatch,
      (data) => {
        callback({ success: 1, message: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addAdminReports(session, data, callback) {
  var body = { resource: { ...data } };
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket`;

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function addReports_tracker(session, data, callback) {
  var body = { resource: { ...data } };
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket_messages`;

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function fetchadminissueTokenOpen(session, clientid, callback) {
  var filter = encodeURI(`(clientidfk=${clientid})AND(status=open)`);
  let orderBy = `updateon%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket?related=clients_by_reportedby,support_ticket_messages_by_reportissueidfk&filter=${filter}&order=${orderBy}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: ADMIN_ISSUE_TOKEN_OPEN, payload: data.resource });
        callback({ status: 1, data: data.resource });
      },
      (error) => {}
    );
  };
}

export function fetchadminissueTokenClose(session, clientid, callback) {
  var filter = encodeURI(`(clientidfk=${clientid})AND(status=closed)`);
  let orderBy = `updateon%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket?related=clients_by_reportedby,support_ticket_messages_by_reportissueidfk&filter=${filter}&order=${orderBy}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: ADMIN_ISSUE_TOKEN_CLOSE, payload: data.resource });
        callback({ status: 1, data: data.resource });
      },
      (error) => {}
    );
  };
}

export function updateClientdata(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/clients`;
  let body = { resource: values };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateissueStatus(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket`;
  let body = { resource: values };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function addinvoicepayement(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        if (response.success == 0) {
          callback({ success: 0 });
        } else {
          callback({ success: 1, data: response });
        }
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  };
}
export function addinvoicepayementfromOpenLink(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/billingpaymentfromopenlink`;
  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        if (response.success == 0) {
          callback({ success: 0 });
        } else {
          callback({ success: 1, data: response });
        }
      },
      (error) => {
        console.log("error", error);
        callback({ success: 0, data: error });
      }
    );
  };
}

export function updatetoInvoice(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/clientinvoice`;
  let body = { resource: values };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function downloadInvoicePdf(session, id, callback) {
  // console.log('sessionid',session)
  var config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type",
      "content-Type": "application/x-www-form-urlencoded",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };
  var url = `${MAIN_URL}/pdfgenerate/billinginvoicedownload/index.php?id=${id}`;

  var body = {
    id: id,
  };

  var response = axios.post(url, body, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, message: data });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

// export function fetcheventsunderClients(session,clientid,callback) {
//   var filter = encodeURI(
//     `(clientidfk=${clientid})`
//   );
//   var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=eventname,eventid&filter=${filter}`;

//   return (dispatch) => {
//     getRequest(
//       url,
//       session,
//       dispatch,
//       (data) => {
//         dispatch({ type: ALLEVENTS_UNDERCLIENT, payload: data.resource });
//         callback({ status: 1 ,data: data.resource });
//       },
//       (error) => {}
//     );
//   };
// }

export function fetcheventsunderClients(session, clientid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    postRequest(
      url,
      {
        clientid: clientid,
        type: "geteventsunderclient",
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: ALLEVENTS_UNDERCLIENT,
          payload: { data: response.result },
        });

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchsingleReport(session, id, callback) {
  var filter = encodeURI(`(id=${id})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket?filter=${filter}&related=clients_by_reportedby,clients_by_clientidfk,support_ticket_messages_by_reportissueidfk`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: SINGLEREPORT,
          payload: {
            data: data.resource,
          },
        });
        callback({ status: 1, data: data.resource });
      },
      (error) => {}
    );
  };
}

export function updateReports_tracker(session, data, callback) {
  var body = { resource: { ...data } };
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/support_ticket_messages`;

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function sendnewticketEmailtoclient(session, obj, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  return (dispatch) => {
    postRequest(
      url,
      obj,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function sendnewsupportTicketetointernal(session, obj, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  return (dispatch) => {
    postRequest(
      url,
      obj,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function closeIssueemail(session, obj, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  return (dispatch) => {
    postRequest(
      url,
      obj,
      {},
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}
